module.exports = __webpack_public_path__ + "static/media/awards.4ef70c01.webp";